import { SET_PARKINGS, ADD_PARKING, UPDATE_PARKING, REMOVE_PARKING, CLEAR_PARKINGS } from 'actions';

// { id: string, lat: number, lng: number, address: string, duration: number }
const initialState = [];

export default (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case SET_PARKINGS:
      return payload;
    case ADD_PARKING:
      return [...state, payload];
    case UPDATE_PARKING: {
      const { id, ...props } = payload;
      return state.map((p) => (p.id === id ? { ...p, ...props } : p));
    }
    case REMOVE_PARKING:
      return state.filter((p) => p.id !== payload);
    case CLEAR_PARKINGS:
      return initialState;
    default:
      return state;
  }
};
